<div class="prueba-sidebar">
  <nav id="sidebar" class="sidebar">
    <!-- <a class="sidebar-brand"  href="#/dashboard"  >
      <div class="img-logo d-flex align-items-center">
        <img src="/assets/img/orbis/orbisIcon.png" width="50" height="50" alt="">
        <h1 class="m-0 text-white text-logo-icon ms-3">RBIS</h1>
      </div>
    </a> -->
    <div (click)="home()">
      <a class="d-flex link-logo" href="#/dashboard" style="height: 64px;">
        <div class="img-logo d-flex align-items-center ps-2">
          <img src="/assets/img/orbis/logotipo-final-orbis.png" height="50" alt="">
          <!--h1 class="m-0 text-white text-logo-icon ms-3">ORBIS</h1-->
        </div>
      </a>
    </div>

    <div class="sidebar-content">
      <ul class="sidebar-nav">

        <div>
          <div class="accordion" id="accordionAdmin">
            <!--ADMINISTRATION-->
            <div class="accordion-item" *ngIf="userRole =='admin'">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" (click)="toggleAccordion('admin')"
                  [class.collapsed]="activeAccordion !== 'admin'" [attr.aria-expanded]="activeAccordion === 'admin'">
                  <i class="fas fa-file-signature me-2 "></i>
                  <span class="align-middle ">{{"administration" | translate}}</span>
                </button>
              </h2>

              <div id="collapseAdmin" class="accordion-collapse" [class.collapse]="activeAccordion !== 'admin'"
                [class.show]="activeAccordion === 'admin'">
                <div class="accordion-body">
                  <li class="sidebar-item">
                    <a class="sidebar-link" (click)="deleteUserDevice()"
                      routerLink="/dashboard/administration/search">{{"search" | translate}}</a>
                  </li>
                  <li class="sidebar-item">
                    <a class="sidebar-link" (click)="deleteUserDevice()"
                      routerLink="/dashboard/administration/addUser">{{"addUserToDevice" | translate}}</a>
                  </li>
                  <li class="sidebar-item">
                    <a class="sidebar-link" routerLink="/dashboard/administration/sendCommand">{{"sendCommands" |
                      translate}}</a>
                  </li>
                  <li class="sidebar-item">
                    <a class="sidebar-link" routerLink="/dashboard/administration/testers">{{"testers" | translate}}</a>
                  </li>
                  <li class="sidebar-item"><a class="sidebar-link"
                      (click)="clickDiagnosis();deleteUserDevice()">{{"diagnosis" | translate}}</a></li>
                  <li class="sidebar-item">
                    <a class="sidebar-link" (click)="deleteUserDevice()"
                      routerLink="/dashboard/administration/logs">{{"historicSidebar" | translate}}</a>
                  </li>
                </div>
              </div>
            </div>
            <!--DEVELOPER SETTINGS-->
            <div class="accordion-item" *ngIf="userRole=='admin' || userRole=='developer'">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" (click)="toggleAccordion('developer')"
                  [class.collapsed]="activeAccordion !== 'developer'"
                  [attr.aria-expanded]="activeAccordion === 'developer'">
                  <i class="fas fa-code me-2"></i> <span class="align-middle">{{"developerSettings" | translate}}</span>
                </button>
              </h2>
              <div id="collapseDevSettings" class="accordion-collapse"
                [class.collapse]="activeAccordion !== 'developer'" [class.show]="activeAccordion === 'developer'">
                <div class="accordion-body">
                  <li class="sidebar-item"><a class="sidebar-link"
                      routerLink="/developers/documentation/mqtt_api">{{"mqttApi" | translate}}</a></li>
                  <li class="sidebar-item"><a class="sidebar-link"
                      routerLink="/developers/settings/pat-token">{{"patToken" | translate}}</a></li>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--DEVICES-->

        <div class="p-0 devicesGroupsBlock" *ngIf="userRole =='admin' || hasGroupSubscription()">
          <!-- Sidebar -->

          <div class="d-flex w-100 m-auto button-group-container ">
            <div class=" w-50 text-center p-1 button-group" (click)="changeView('devices')"
              [ngClass]="{'bg-white text-black' : view === 'devices' }" data-cy="sidebarDevicesButton">
              {{"devices" | translate}}
            </div>
            <div class="w-50 text-center p-1 button-group" (click)="changeView('groups')"
              [ngClass]="{'bg-white text-black' : view === 'groups' }" data-cy="sidebarGroupsButton">
              {{"groups" | translate}}
            </div>
          </div>

          <div class="" id="sidebar-wrapper">

            <div class="text-muted listItemsGroups" [class.listItemsGroups--withAddBtn]="userRole=='admin' || hasGroupSubscription()" *ngIf="view === 'groups'">
              <li class="sidebar-header">
                <form class="form-inline d-none d-sm-inline-block mt-2">
                  <input class="form-control" type="text" name="filteredGroup" [(ngModel)]="filteredGroup"
                    placeholder="{{'Buscar grupo' | translate}}" data-cy="sidebarSearchGroups">
                </form>
              </li>
              <div class="devices-sidebar-groups pt-2">
                <div *ngFor="let node of data | filterGroups:filteredGroup; let i = index; trackBy: trackByFn"
                  class="mb-2 ms-1" style="cursor: pointer;">
                  <!-- Nodo Padre -->
                  <div class="d-flex align-items-center ps-2"
                    [ngClass]="{'selected-item bg-primary': node.alias === selectedNode}">
                    <span *ngIf="node.isExpanded" (click)="toggleNode(node, node.devices, i, false)"><i
                        class="fa-solid fa-chevron-down"></i></span>
                    <span *ngIf="!node.isExpanded" (click)="toggleNode(node, node.devices, i, false)"><i
                        class="fa-solid fa-angle-right"></i></span>
                    <div (click)="toggleNode(node, node.devices, i)" class="d-flex align-items-center">
                      <span class="ms-2"><i class="fa-solid fa-layer-group me-2"></i></span>
                      <span>{{ node.name }}</span>
                    </div>
                  </div>

                  <!-- Subgrupos del nodo padre al expandir -->
                  <div *ngIf="node.isExpanded">
                    <div *ngFor="let child of node.subgroups" class="ms-4 mt-1">
                      <!-- Subgrupo -->
                      <div class="d-flex align-items-center ps-2" [ngClass]="{
                        'selected-item bg-primary': child.alias === selectedNode
                      }">
                        <span *ngIf="child.isExpanded" (click)="clickGroup(node, child, false)"><i
                            class="fa-solid fa-chevron-down"></i></span>
                        <span *ngIf="!child.isExpanded" (click)="clickGroup(node, child, false)"><i
                            class="fa-solid fa-angle-right"></i></span>
                        <div (click)="clickGroup(node, child)" class="d-flex align-items-center">
                          <span class="ms-2"><i class="fa-solid fa-layer-group"></i></span>
                          <span>{{ child.name }}</span>
                        </div>
                      </div>

                      <!-- Subgrupos y dispositivos del hijo -->
                      <div *ngIf="child.isExpanded">
                        <!-- Subgrupos del hijo -->
                        <div *ngFor="let grandchild of child.children" class="ms-4 mt-1">
                          <div class="d-flex align-items-center ps-2" [ngClass]="{
                            'selected-item bg-primary': grandchild.alias === selectedNode
                          }">
                            <span *ngIf="grandchild.isExpanded"
                              (click)="clickGrandchild(node, child, grandchild, false)"><i
                                class="fa-solid fa-chevron-down"></i></span>
                            <span *ngIf="!grandchild.isExpanded"
                              (click)="clickGrandchild(node, child, grandchild, false)"><i
                                class="fa-solid fa-angle-right"></i></span>
                            <div (click)="clickGrandchild(node, child, grandchild)" class="d-flex align-items-center">
                              <span class="ms-2"><i class="fa-solid fa-layer-group"></i></span>
                              <span>{{ grandchild.name }}</span>
                            </div>
                          </div>

                          <!-- Dispositivos del nieto -->
                          <div *ngIf="grandchild.isExpanded" class="ms-4">
                            <div *ngFor="let device of grandchild.devices" (click)="clickDevice(device.serial)"
                              class="d-flex align-items-top mt-1 ps-2" style="cursor: pointer;"
                              [ngClass]="{'selected-item bg-primary': device.serial?.toLowerCase() === paramDevice?.toLowerCase()}">
                              <i class="fas fa-charging-station me-1 mt-1 text-success"
                                *ngIf="device.alive == 1 && device.serial.includes('EVVC')"></i>
                              <i class="fas fa-charging-station me-1 mt-1 text-danger"
                                *ngIf="device.alive == 0 && device.serial.includes('EVVC')"></i>
                              <div class="position-relative d-inline-flex align-items-center justify-content-center flex-shrink-0 me-1 mt-1" style="width: 1.2em; height: 1.2em;"
                                *ngIf="device.alive == 1 && !device.serial.includes('EVVC') && checkOut(device.serial)">
                                <i class="fa-solid fa-lightbulb text-warning-2"></i>
                              </div>
                              <div class="position-relative d-inline-flex align-items-center justify-content-center flex-shrink-0 me-1 mt-1" style="width: 1.2em; height: 1.2em;"
                                *ngIf="device.alive == 1 && !device.serial.includes('EVVC') && !checkOut(device.serial)">
                                <i class="fa-solid fa-lightbulb" style="color: #808080;"></i>
                              </div>
                              <div class="position-relative d-inline-flex align-items-center justify-content-center flex-shrink-0 me-1 mt-1" style="width: 1.2em; height: 1.2em;"
                                *ngIf="device.alive == 0 && !device.serial.includes('EVVC')">
                                <i class="fa-solid fa-lightbulb text-danger"></i>
                              </div>
                              <span class="row">
                                <span *ngIf="!device.name">{{ device.serial }}</span>
                                <span *ngIf="device.name">{{ device.name }}</span>
                                <small *ngIf="device.name" class="text-secondary" style="width: fit-content;">
                                  {{device.serial}} </small>
                              </span>
                            </div>
                          </div>
                        </div>

                        <!-- Línea de separación -->
                        <hr class="m-1" *ngIf="child.children?.length > 0 && child.devices?.length > 0">

                        <!-- Dispositivos del hijo -->
                        <div *ngFor="let device of child.devices" (click)="clickDevice(device.serial)"
                          class="d-flex align-items-top mt-1 ms-4 ps-2" style="cursor: pointer;"
                          [ngClass]="{'selected-item bg-primary': device.serial?.toLowerCase() === paramDevice?.toLowerCase()}">
                          <i class="fas fa-charging-station me-1 mt-1 text-success"
                            *ngIf="device.alive == 1 && device.serial.includes('EVVC')"></i>
                          <i class="fas fa-charging-station me-1 mt-1 text-danger"
                            *ngIf="device.alive == 0 && device.serial.includes('EVVC')"></i>
                          <div class="position-relative d-inline-flex align-items-center justify-content-center flex-shrink-0 me-1 mt-1" style="width: 1.2em; height: 1.2em;"
                            *ngIf="device.alive == 1 && !device.serial.includes('EVVC') && checkOut(device.serial)">
                            <i class="fa-solid fa-lightbulb text-warning-2"></i>
                          </div>
                          <div class="position-relative d-inline-flex align-items-center justify-content-center flex-shrink-0 me-1 mt-1" style="width: 1.2em; height: 1.2em;"
                            *ngIf="device.alive == 1 && !device.serial.includes('EVVC') && !checkOut(device.serial)">
                            <i class="fa-solid fa-lightbulb" style="color: #808080;"></i>
                          </div>
                          <div class="position-relative d-inline-flex align-items-center justify-content-center flex-shrink-0 me-1 mt-1" style="width: 1.2em; height: 1.2em;"
                            *ngIf="device.alive == 0 && !device.serial.includes('EVVC')">
                            <i class="fa-solid fa-lightbulb text-danger"></i>
                          </div>

                          <span class="row">
                            <span *ngIf="!device.name">{{ device.serial }}</span>
                            <span *ngIf="device.name">{{ device.name }}</span>
                            <small *ngIf="device.name" class="text-secondary" style="width: fit-content;">
                              {{device.serial}} </small>
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- Dispositivos del nodo padre -->
                    <hr class="m-1" *ngIf="node.subgroups?.length > 0 && node.devices?.length > 0">
                    <div *ngFor="let device of node.devices" (click)="clickDevice(device.serial)"
                      class="d-flex align-items-top mt-1 ms-3 ps-2" style="cursor: pointer;"
                      [ngClass]="{'selected-item bg-primary': device.serial?.toLowerCase() === paramDevice?.toLowerCase()}">
                      <i class="fas fa-charging-station me-1 mt-1 text-success"
                        *ngIf="device.alive == 1 && device.serial.includes('EVVC')"></i>
                      <i class="fas fa-charging-station me-1 mt-1 text-danger"
                        *ngIf="device.alive == 0 && device.serial.includes('EVVC')"></i>
                      <div class="position-relative d-inline-flex align-items-center justify-content-center flex-shrink-0 me-1 mt-1" style="width: 1.2em; height: 1.2em;"
                        *ngIf="device.alive == 1 && !device.serial.includes('EVVC') && checkOut(device.serial)">
                        <i class="fa-solid fa-lightbulb text-warning-2"></i>
                      </div>
                      <div class="position-relative d-inline-flex align-items-center justify-content-center flex-shrink-0 me-1 mt-1" style="width: 1.2em; height: 1.2em;"
                        *ngIf="device.alive == 1 && !device.serial.includes('EVVC') && !checkOut(device.serial)">
                        <i class="fa-solid fa-lightbulb" style="color: #808080;"></i>
                      </div>
                      <div class="position-relative d-inline-flex align-items-center justify-content-center flex-shrink-0 me-1 mt-1" style="width: 1.2em; height: 1.2em;"
                        *ngIf="device.alive == 0 && !device.serial.includes('EVVC')">
                        <i class="fa-solid fa-lightbulb text-danger"></i>
                      </div>
                      <span class="row">
                        <span *ngIf="!device.name" class="pe-0" style="width: 100%;">{{ device.serial }}</span>
                        <span *ngIf="device.name" class="pe-0" style="width: 100%;">{{ device.name }}</span>
                        <small *ngIf="device.name" class="text-secondary" style="width: fit-content;">
                          {{device.serial}} </small>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>




            <div *ngIf="view=='devices'" class="listItems h-100">

              <li class="sidebar-header">
                <ng-template #deviceFilterPopoverContentAdmin>
                  <div class="d-grid gap-2">
                    <button type="button" class="btn btn-sm text-start"
                      [ngClass]="deviceTypeFilter === 'all' ? 'btn-primary' : 'btn-outline-secondary'"
                      (click)="setDeviceTypeFilter('all')">
                      <i class="fa-solid fa-list me-1"></i> Todos
                    </button>
                    <button type="button" class="btn btn-sm text-start"
                      [ngClass]="deviceTypeFilter === 'evvc' ? 'btn-primary' : 'btn-outline-secondary'"
                      (click)="setDeviceTypeFilter('evvc')">
                      <i class="fas fa-charging-station me-1"></i> Cargadores
                    </button>
                    <button type="button" class="btn btn-sm text-start"
                      [ngClass]="deviceTypeFilter === 'lighting' ? 'btn-primary' : 'btn-outline-secondary'"
                      (click)="setDeviceTypeFilter('lighting')">
                      <i class="fa-solid fa-lightbulb me-1"></i> Alumbrado
                    </button>
                  </div>
                </ng-template>
                <form class="form-inline d-none d-sm-inline-block mt-2">
                  <div class="input-group input-group-sm">
                    <input class="form-control" type="text" name="filteredSerial" [(ngModel)]="filteredSerial"
                      placeholder="{{'searchDevices' | translate}}" data-cy="sidebarSearchDevices">
                    <button type="button" class="btn btn-outline-secondary"
                      [ngbPopover]="deviceFilterPopoverContentAdmin" placement="bottom-end" container="body"
                      popoverClass="device-filter-popover"
                      aria-label="Filtro de dispositivos" title="Filtro">
                      <i class="fa-solid fa-filter"></i>
                    </button>
                  </div>
                </form>
              </li>
              <div class="devices-sidebar">
                <div *ngFor="let device of devices | filterDevices:filteredSerial"
                  class="d-flex align-items-top mt-1 ms-3 ps-2"
                  [class.d-none]="!isDeviceTypeVisible(device)"
                  [ngClass]="{'selected-item bg-primary': device.serial?.toLowerCase() === paramDevice?.toLowerCase()}">
                  <div class="d-flex align-items-top flex-grow-1" (click)="clickDevice(device.serial)"
                    style="cursor: pointer;">
                    <i class="fas fa-charging-station me-1 mt-1 text-success"
                      *ngIf="device.alive == 1 && device.serial.includes('EVVC')"></i>
                    <i class="fas fa-charging-station me-1 mt-1 text-danger"
                      *ngIf="device.alive == 0 && device.serial.includes('EVVC')"></i>
                    <div class="position-relative d-inline-flex align-items-center justify-content-center flex-shrink-0 me-1 mt-1" style="width: 1.2em; height: 1.2em;"
                      *ngIf="device.alive == 1 && !device.serial.includes('EVVC') && checkOut(device.serial)">
                      <i class="fa-solid fa-lightbulb text-warning-2"></i>
                    </div>
                    <div class="position-relative d-inline-flex align-items-center justify-content-center flex-shrink-0 me-1 mt-1" style="width: 1.2em; height: 1.2em;"
                      *ngIf="device.alive == 1 && !device.serial.includes('EVVC') && !checkOut(device.serial)">
                      <i class="fa-solid fa-lightbulb" style="color: #808080;"></i>
                    </div>
                    <div class="position-relative d-inline-flex align-items-center justify-content-center flex-shrink-0 me-1 mt-1" style="width: 1.2em; height: 1.2em;"
                      *ngIf="device.alive == 0 && !device.serial.includes('EVVC')">
                      <i class="fa-solid fa-lightbulb text-danger"></i>
                    </div>
                    <span class="row align-items-center">
                      <span *ngIf="!device.name" class="pe-0" style="width: 100%;">{{ device.serial }}</span>
                      <span *ngIf="device.name" class="pe-0" style="width: 100%;">{{ device.name }}</span>
                      <small *ngIf="device.name" class="text-secondary" style="width: fit-content;">
                        {{device.serial}} </small>
                    </span>
                  </div>
                  <div (click)="toogleFavoriteDevice(device.serial, device.favorite)" style="cursor: pointer;"
                    class="me-1">
                    <div *ngIf="!device.favorite">
                      <i class="fa-solid fa-thumbtack-slash text-muted opacity-25"></i>
                    </div>
                    <!-- <div *ngIf="isFavorite(device.serial)" class="me-1" > -->
                    <div *ngIf="device.favorite" class="me-1">
                      <i class="fa-thumbtack fa-solid pinned text-warning"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button *ngIf="view=='groups' && (userRole=='admin' || hasGroupSubscription())" class="my-float bg-primary" (click)="addGroup()"><i
              class="fa fa-plus"></i></button>
        </div>


        <!--DEVICES-->
        <div class="p-0 devicesGroupsBlock" *ngIf="userRole !='admin' && !hasGroupSubscription()">
          <div class="listItems h-100">

          <li class="sidebar-header">
            {{"devices" | translate}}
            <ng-template #deviceFilterPopoverContentUser>
              <div class="d-grid gap-2">
                <button type="button" class="btn btn-sm text-start"
                  [ngClass]="deviceTypeFilter === 'all' ? 'btn-primary' : 'btn-outline-secondary'"
                  (click)="setDeviceTypeFilter('all')">
                  <i class="fa-solid fa-list me-1"></i> Todos
                </button>
                <button type="button" class="btn btn-sm text-start"
                  [ngClass]="deviceTypeFilter === 'evvc' ? 'btn-primary' : 'btn-outline-secondary'"
                  (click)="setDeviceTypeFilter('evvc')">
                  <i class="fas fa-charging-station me-1"></i> Cargadores
                </button>
                <button type="button" class="btn btn-sm text-start"
                  [ngClass]="deviceTypeFilter === 'lighting' ? 'btn-primary' : 'btn-outline-secondary'"
                  (click)="setDeviceTypeFilter('lighting')">
                  <i class="fa-solid fa-lightbulb me-1"></i> Alumbrado
                </button>
              </div>
            </ng-template>
            <form class="form-inline d-none d-sm-inline-block mt-2">
              <div class="input-group input-group-sm">
                <input class="form-control" type="text" name="filteredSerial" [(ngModel)]="filteredSerial"
                  placeholder="{{'searchDevices' | translate}}">
                <button type="button" class="btn btn-outline-secondary"
                  [ngbPopover]="deviceFilterPopoverContentUser" placement="bottom-end" container="body"
                  popoverClass="device-filter-popover"
                  aria-label="Filtro de dispositivos" title="Filtro">
                  <i class="fa-solid fa-filter"></i>
                </button>
              </div>
            </form>
          </li>
          <div class="devices-sidebar">
            <div *ngFor="let device of devices | filterDevices:filteredSerial"
              class="d-flex align-items-top mt-1 ms-3 ps-2"
              [class.d-none]="!isDeviceTypeVisible(device)"
              [ngClass]="{'selected-item bg-primary': device.serial?.toLowerCase() === paramDevice?.toLowerCase()}">
              <div class="d-flex align-items-top flex-grow-1" (click)="clickDevice(device.serial)"
                style="cursor: pointer;">
                <i class="fas fa-charging-station me-1 mt-1 text-success"
                  *ngIf="device.alive == 1 && device.serial.includes('EVVC')"></i>
                <i class="fas fa-charging-station me-1 mt-1 text-danger"
                  *ngIf="device.alive == 0 && device.serial.includes('EVVC')"></i>
                <div class="position-relative d-inline-flex align-items-center justify-content-center flex-shrink-0 me-1 mt-1" style="width: 1.2em; height: 1.2em;"
                  *ngIf="device.alive == 1 && !device.serial.includes('EVVC') && checkOut(device.serial)">
                  <i class="fa-solid fa-lightbulb text-warning-2"></i>
                  <span class="icon-indicator alive position-absolute" style="top: -2px; left: -2px;"></span>
                </div>
                <div class="position-relative d-inline-flex align-items-center justify-content-center flex-shrink-0 me-1 mt-1" style="width: 1.2em; height: 1.2em;"
                  *ngIf="device.alive == 1 && !device.serial.includes('EVVC') && !checkOut(device.serial)">
                  <i class="fa-solid fa-lightbulb" style="color: #808080;"></i>
                </div>
                <div class="position-relative d-inline-flex align-items-center justify-content-center flex-shrink-0 me-1 mt-1" style="width: 1.2em; height: 1.2em;"
                  *ngIf="device.alive == 0 && !device.serial.includes('EVVC')">
                  <i class="fa-solid fa-lightbulb text-danger"></i>
                </div>
                <span class="row align-items-center">
                  <span *ngIf="!device.name" class="pe-0" style="width: 100%;">{{ device.serial }}</span>
                  <span *ngIf="device.name" class="pe-0" style="width: 100%;">{{ device.name }}</span>
                  <small *ngIf="device.name" class="text-secondary" style="width: fit-content;">
                    {{device.serial}} </small>
                </span>
              </div>
              <div (click)="toogleFavoriteDevice(device.serial, device.favorite)" style="cursor: pointer;" class="me-1">
                <div *ngIf="!device.favorite">
                  <i class="fa-solid fa-thumbtack-slash text-muted opacity-25"></i>
                </div>
                <div *ngIf="device.favorite" class="me-1">
                  <i class="fa-thumbtack fa-solid pinned text-warning"></i>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>


      </ul>
    </div>
  </nav>
</div>
